import React from 'react';
import {
  Body,
  Button,
  Headline,
  Icon,
  designSystemToken,
} from '@lightricks/react-design-system';
import styles from './EmptyState.module.scss';

type EmptyStateProps = {
  testID?: string;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
};

function EmptyState({
  testID = 'empty-state',
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div data-testid={testID} className={styles.container}>
      <div className={styles.textBlock}>
        <Headline size="sm" color={designSystemToken('semantic.fg.primary')}>
          {title}
        </Headline>
        {description ? (
          <Body size="md" color={designSystemToken('semantic.fg.secondary')}>
            {description}
          </Body>
        ) : null}
      </div>
      {action ? (
        <Button
          appearance="neutral"
          mode="filled"
          size="medium"
          onClick={action.onClick}
          icon={
            <Icon
              size="small"
              appearance="inverse"
              name="Actions-Arrow-Long-Forward"
            />
          }
          iconPosition="end"
        >
          {action.label}
        </Button>
      ) : null}
    </div>
  );
}

export default EmptyState;
